// Ported from src/components/landing/landingHeroConstants.ts (landing port).
/** 랜딩 히어로 본문 심볼 — `public/images/tokens/tycoon-symbol.webp` */
export const LANDING_TYCOON_SYMBOL_SRC = "/images/tokens/tycoon-symbol.webp";

/** 데스크톱·넓은 뷰포트 (md 이상): `public/videos/tycoon-arena-trailer-main.mp4` */
export const HERO_TRAILER_MP4_MAIN = "/videos/tycoon-arena-trailer-main.mp4";
/** 모바일·좁은 뷰포트: `public/videos/tycoon-arena-trailer-mobile.mp4` */
export const HERO_TRAILER_MP4_MOBILE = "/videos/tycoon-arena-trailer-mobile.mp4";
/** 재생 전 정적 프레임 — 각각 대응 mp4 1초 지점에서 추출한 16:9 WebP (`scripts/ffmpeg-web-video.example.sh` 가 갱신). */
export const HERO_TRAILER_POSTER_DESKTOP = "/images/arena/tycoon-arena-trailer-poster-desktop.webp";
export const HERO_TRAILER_POSTER_MOBILE = "/images/arena/tycoon-arena-trailer-poster-mobile.webp";
